import React from 'react'
import { get } from 'lodash'
import { Redirect } from 'react-router-dom'

import config from 'config'
import { AwardUnit as AwardUnitPage } from 'containers/pages/register'
import * as AwardUnit from 'containers/forms/awardUnit'

const urlPrefix = `${config.publicPath}/register/award-unit`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <AwardUnitPage logout {...props} />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: props => (
          <Redirect to={{
            pathname: `${config.publicPath}/register/award-unit/select`,
            search: get(props, 'location.search')
          }}
          />
        ),
        routes: []
      },
      {
        path: `${urlPrefix}/select`,
        exact: true,
        component: props => (
          <AwardUnit.Select {...props} />
        ),
        activeId: 1,
        routes: []
      },
      {
        path: `${urlPrefix}/details`,
        exact: true,
        component: props => (
          <AwardUnit.Details {...props} />
        ),
        activeId: 2,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/authorising-contact`,
        exact: true,
        component: props => (
          <AwardUnit.AuthorisingContact {...props} />
        ),
        activeId: 3,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/nominated-award-leader`,
        exact: true,
        component: props => (
          <AwardUnit.NominatedAwardLeader {...props} />
        ),
        activeId: 4,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/award-leader-contact`,
        exact: true,
        component: props => (
          <AwardUnit.AwardLeaderContact {...props} />
        ),
        activeId: 5,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/orb-account`,
        exact: true,
        component: props => (
          <AwardUnit.Account {...props} />
        ),
        activeId: 6,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/success`,
        exact: true,
        component: props => (
          <AwardUnit.Success {...props} />
        ),
        activeId: 7,
        hideLocaleSwitcher: true,
        routes: []
      }
    ]
  }
]
